import { createReducer } from './utils';
import {
  UPDATE_FILTER,
  UPDATE_PREV_FILTER,
  CREATE_FILTER_LIST,
  UPDATE_SUPPLIER,
  RESET_SUPPLIER
} from './constants';

const DEFAULT_FILTER = {
  completed: false,
  priority: false,
  supplier_id: null,
};

const defaultState = {
  filters: DEFAULT_FILTER,
  prevFilters: {},
  filterList: {},
  supplierSelected: { 'id': 'all', 'title': 'All' },
};

// reducer
export const reducer = createReducer(defaultState, {
  [UPDATE_FILTER]: handleUpdateFilter,
  [UPDATE_PREV_FILTER]: handleUpdatePrevFilter,
  [CREATE_FILTER_LIST]: halndlerCreateFilterList,
  [UPDATE_SUPPLIER]: handleSelectedSupplier,
  [RESET_SUPPLIER]: handleResetSupplier,
});

function handleUpdateFilter(state, { payload: { newFilters } }) {
  return {
    ...state,
    filters: newFilters,
  };
}

function handleUpdatePrevFilter(state, { payload: { newFilters } }) {
  return {
    ...state,
    prevFilters: newFilters,
  };
}

function halndlerCreateFilterList(state, { payload: { newFilterList } }) {
  return {
    ...state,
    filterList: newFilterList,
  };
}
function handleSelectedSupplier(state, { payload: { supplierSelected } }) {
  return {
    ...state,
    supplierSelected: supplierSelected,
  };
}
function handleResetSupplier(state, action) {
  return {
    ...state,
    supplierSelected: { 'id': 'all', 'title': 'All' },
  };
}

// actions
export function addFilter(title, value) {
  return async (dispatch, getState, { services: { } }) => {
    const {
      filters: { filters },
    } = getState();

    try {
      let newFilters = Object.assign({}, filters);
      if (title === 'task_type' || title === 'supplier_id') {
        newFilters[title] = value;
      } else {
        if (newFilters[title] !== value) {
          newFilters[title] = value;
        } else {
          delete newFilters[title];
        }
      }
      dispatch({ type: UPDATE_FILTER, payload: { newFilters } });
    } catch (error) {
      console.log('addFilter error', error);
    }
  };
}

export function resetFilter() {
  return async (dispatch, getState, { services: { } }) => {
    const {
      tasks: { currentTaskType },
    } = getState();
    try {
      let newFilters = Object.assign({}, DEFAULT_FILTER);
      newFilters['task_type'] = currentTaskType;
      dispatch({ type: UPDATE_FILTER, payload: { newFilters } });
      dispatch({ type: RESET_SUPPLIER });
    } catch (error) {
      console.log('resetFilter error', error);
    }
  };
}

export function cancelFilter() {
  return async (dispatch, getState, { services: { } }) => {
    const {
      filters: { prevFilters },
    } = getState();

    try {
      let newFilters = prevFilters;

      dispatch({ type: UPDATE_FILTER, payload: { newFilters } });
    } catch (error) {
      console.log('cancelFilter error', error);
    }
  };
}

export function updatePrevFilter() {
  return async (dispatch, getState, { services: { } }) => {
    const {
      filters: { filters },
    } = getState();

    try {
      let newFilters = filters;

      dispatch({ type: UPDATE_PREV_FILTER, payload: { newFilters } });
    } catch (error) {
      console.log('updatePrevFilter error', error);
    }
  };
}

export function createFilterList() {
  return async (dispatch, getState, { services: { } }) => {
    const {
      tasks: { resourcesTasksType },
    } = getState();

    try {
      let newFilterList = {};
      let taskTypeList = resourcesTasksType.map(element => element.task_type);
      newFilterList['task_type'] = taskTypeList;

      dispatch({ type: CREATE_FILTER_LIST, payload: { newFilterList } });
    } catch (error) {
      console.log('createFilterList error', error);
    }
  };
}

export function setSupplierSelected(supplierSelected) {
  return async (dispatch, getState, { services: { } }) => {
    try {
      dispatch({ type: UPDATE_SUPPLIER, payload: { supplierSelected } });
    } catch (error) {
      console.log('update supplierSelected', error);
    }
  };
}